/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/packages-source-foundations-accessibility-helpers--page#visually-hidden-elements)
 *
 * For elements that need to be hidden from sighted users and displayed to screen reader users.
 */

export const visuallyHidden = `
	position: absolute;
	opacity: 0;
	height: 0;
	width: 0;
	top: 0;
	left: 0;
`;
